<app-view-dashboard-component>
  <div modalTitle>
    {{ 'nav.sales' | translate }}
  </div>
  <div class="ion-margin-top">
    <app-contracts></app-contracts>
  </div>
</app-view-dashboard-component>